// @flow

import React, { useRef, useEffect } from "react";

import User from "src/components/user/Photo";
import NameOrEmail from "src/containers/user/NameOrEmail";
import { UserInfo, ChatCard } from "src/components/messages/Chat/styles";
import MessageCard from "src/components/messages/Chat/MessageCard";

import type { UID, RoomId, UserTyping } from "src/types";

import TypingIndicator from "./TypingAnimation";
import { ChatIndicatorWrapper } from "./styles";

type Props = {
  uid: UID,
  roomId: RoomId,
  typing: Array<UserTyping>,
};

const TypingItem = ({ uid }: Props) => {
  const indicatorRef = useRef();

  useEffect(() => {
    if (indicatorRef) {
      // $FlowFixMe
      indicatorRef?.current?.scrollIntoView();
    }
  }, [indicatorRef]);

  return (
    <ChatIndicatorWrapper>
      <ChatCard first showSelect={false}>
        <UserInfo ref={indicatorRef}>
          <User uid={uid} size="sm" />
        </UserInfo>
        <MessageCard first>
          <NameOrEmail uid={uid} notificationVariant="key" />
          <TypingIndicator />
        </MessageCard>
      </ChatCard>
    </ChatIndicatorWrapper>
  );
};

export default TypingItem;
